import { Component } from '@angular/core';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-cancel-draft-success-modal',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './cancel-draft-success-modal.component.html',
  styleUrl: './cancel-draft-success-modal.component.scss'
})
export class CancelDraftSuccessModalComponent {

}
